import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";

const initialState = {
  showSpinner: false,
}

const mainSlice = createSlice({
  name: "mainSlice",
  initialState,
  reducers: {
    setShowSpinner: (state, action: PayloadAction<boolean>) => {
      state.showSpinner = action.payload;
    }
  }
});

export const {
  setShowSpinner,
} = mainSlice.actions;

export default mainSlice.reducer;